const getFillColor = (
  type: string | undefined,
  selectedIconId: string
): string => (type && type === selectedIconId ? "#4d6e33" : "#929292");

export default { getFillColor };
